import React, { useRef, useState, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import DataGrid from "../../components/DataGrid/index.js";
import Toggle from "../../components/DataGrid/toggle.js";

export default function GrupoList() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const gridRef = useRef();

  const filtroInicial = searchParams.get("filtro") || "";
  const [ativoFiltro, setAtivoFiltro] = useState(searchParams.get("ativo") ?? "true");
  const escopoFiltro = searchParams.get("escopo") || "";

  const getTitulo = () => {
    if (escopoFiltro === "todos") {
      if (ativoFiltro === "true") return "Todos os Grupos Ativos";
      if (ativoFiltro === "false") return "Todos os Grupos Inativos";
      return "Todos os Grupos";
    }
    return "Grupos do Sistema";
  };

  const handleToggleStatus = async (id, ativo) => {
    try {
      await axios.put(`${process.env.REACT_APP_API}/grupos/${id}/status`, {
        id,
        ativo: !ativo
      });
      gridRef.current?.refresh();
    } catch (error) {
      console.error("Erro ao alterar status:", error);
    }
  };

  const handleAtivoChange = (valor) => {
    setAtivoFiltro(valor);
    const params = new URLSearchParams(searchParams);
    if (valor !== "") {
      params.set("ativo", valor);
    } else {
      params.delete("ativo");
    }
    setSearchParams(params);
  };

  const getColumns = () => {
    const baseColumns = [
      {
        field: "nome",
        header: "Nome",
        sortable: true,
      }
    ];

    baseColumns.push({
      key: "ativo",
      header: "Ativo",
      className: "text-center",
      headerClassName: "text-center",
      width: "100px",
      render: (row) => (
        <div onClick={(e) => e.stopPropagation()}>
          <Toggle
            value={row.ativo}
            onChange={() => handleToggleStatus(row.id, row.ativo)}
          />
        </div>
      ),
    });

    baseColumns.push({
      key: "acoes",
      header: "Ações",
      width: "100px",
      className: "text-center",
      headerClassName: "text-center",
      render: (row) => (
        <button
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/grupos/${row.id}`);
          }}
          className="p-2 text-gray-600 hover:text-slate-900 hover:bg-gray-100 rounded"
          title="Editar"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
        </button>
      ),
    });

    return baseColumns;
  };

  // Filtros externos para passar ao DataGrid
  const externalFilters = useMemo(() => {
    const filters = {};
    if (ativoFiltro !== "") filters.ativo = ativoFiltro;
    if (escopoFiltro) filters.escopo = escopoFiltro;
    return filters;
  }, [ativoFiltro, escopoFiltro]);

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <div>
          <h1 className="text-xl font-bold">{getTitulo()}</h1>
          {(ativoFiltro !== "true" || escopoFiltro) && (
            <button
              onClick={() => {
                setAtivoFiltro("true");
                navigate("/grupos?ativo=true");
              }}
              className="text-sm text-blue-600 hover:underline"
            >
              Limpar filtros
            </button>
          )}
        </div>

        {/* Filtro de Ativo */}
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600">Status:</span>
            <select
              value={ativoFiltro}
              onChange={(e) => handleAtivoChange(e.target.value)}
              className="border rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-slate-300"
            >
              <option value="true">Ativos</option>
              <option value="false">Inativos</option>
              <option value="">Todos</option>
            </select>
          </div>
        </div>
      </div>

      <DataGrid
        ref={gridRef}
        endpoint={`${process.env.REACT_APP_API}/grupos`}
        columns={getColumns()}
        filters={externalFilters}
        initialFilter={filtroInicial}
        emptyMessage="Nenhum grupo encontrado"
        emptyAction={
          <button
            onClick={() => navigate("/grupos/novo")}
            className="px-4 py-2 text-sm rounded bg-slate-900 text-white hover:bg-slate-800"
          >
            Cadastrar primeiro grupo
          </button>
        }
        headerAction={
          <button
            onClick={() => navigate("/grupos/novo")}
            className="px-4 py-2 text-sm rounded bg-slate-900 text-white hover:bg-slate-800"
          >
            Novo Grupo
          </button>
        }
        onRowClick={(row) => navigate(`/grupos/${row.id}`)}
      />
    </div>
  );
}